module.exports = __webpack_public_path__ + "img/4432f18.png";